import React from "react"
import { StaticQuery, graphql } from "gatsby"

import { FormattedMessage } from "react-intl"

export default () => (
  <StaticQuery
    query={graphql`
      query HeadingQuery {
        site {
          siteMetadata {
            home {
              title
              description
            }
          }
        }
      }
    `}
    render={data => (
      <div className="pb-16 max-w-5xl">
        <div className="text-4xl font-black mb-2">
          <FormattedMessage id="heroBanner.title" />
        </div>
        <div className="text-lg font-light mb-8">
          <FormattedMessage id="heroBanner.message" />
        </div>
        <a
          href="https://discord.gg/5HdTCGQqYH"
          rel="noreferrer"
          target="_blank"
          className="button"
        >
          <FormattedMessage id="heroBanner.visitDiscordButton" />
        </a>
      </div>
    )}
  />
)
